var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    fillRule: "nonzero",
    d: "M3.247 11.91h1.914v.551c0 .462-.425.88-1.276 1.253v1.253c.955-.212 1.593-.5 1.914-.864.321.363.959.652 1.914.864v-1.253c-.85-.374-1.276-.791-1.276-1.253V3.84c0-.462.425-.88 1.276-1.254V1.333c-.955.213-1.593.501-1.914.865-.32-.364-.959-.652-1.914-.865v1.253c.85.374 1.276.792 1.276 1.254v.551H3.247c-1.057 0-1.914.842-1.914 1.88v3.76c0 1.037.857 1.879 1.914 1.879zm-.911-5.64c0-.345.336-.626.752-.626h2.255v5.013H3.088c-.416 0-.752-.28-.752-.627V6.27zM13.047 10.49H8.316v1.17h4.731c.895 0 1.62-.786 1.62-1.755V6.396c0-.969-.725-1.754-1.62-1.754H8.316v1.17h4.731c.298 0 .54.261.54.584v3.509c0 .323-.242.585-.54.585z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.adce3fcfbdb1194a11a2d18077aa1723.svg";
export { ForwardRef as ReactComponent };